import { render, staticRenderFns } from "./dynamic-list.component.vue?vue&type=template&id=0328fa0e&scoped=true"
import script from "./dynamic-list.component.vue?vue&type=script&lang=js"
export * from "./dynamic-list.component.vue?vue&type=script&lang=js"
import style0 from "./dynamic-list.component.vue?vue&type=style&index=0&id=0328fa0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0328fa0e",
  null
  
)

export default component.exports